import { render, staticRenderFns } from "./TwoStepVerify.vue?vue&type=template&id=82d24258&scoped=true"
import script from "./TwoStepVerify.vue?vue&type=script&lang=js"
export * from "./TwoStepVerify.vue?vue&type=script&lang=js"
import style0 from "./TwoStepVerify.vue?vue&type=style&index=0&id=82d24258&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d24258",
  null
  
)

export default component.exports